var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 4500 4500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3443.682,1142.723l785.8,1221.421l-368.735,237.225l-417.368,-648.73l-483.488,750.351l-483.098,-750.724l-417.911,648.498l-368.544,-237.505l786.726,-1220.813l483.066,750.686l483.552,-750.41Z",
    style: {
      fill: "#f07b19",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3284.47,3074.276c0,0 -6.14,-267.789 -74.551,-373.685c-68.411,-105.885 -247.375,-200.084 -357.131,-193.821c-109.772,6.264 -217.415,29.858 -217.415,29.858c0,0 86.809,62.562 119.13,123.173c32.321,60.621 133.081,159.278 195.438,202.036c62.341,42.757 125.917,101.525 125.917,101.525l208.612,110.915Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3284.47,3074.276c0,0 -6.14,-267.789 -74.551,-373.685c-68.411,-105.885 -247.375,-200.084 -357.131,-193.821c-109.772,6.264 -217.415,29.858 -217.415,29.858c0,0 86.809,62.562 119.13,123.173c32.321,60.621 133.081,159.278 195.438,202.036c62.341,42.757 125.917,101.525 125.917,101.525l208.612,110.915Z",
    style: {
      fill: "#d7680b",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3244.472,2992.664c0,0 97.924,-249.305 75.785,-373.426c-22.139,-124.122 -150.734,-280.187 -254.367,-316.869c-103.648,-36.682 -212.04,-56.546 -212.04,-56.546c0,0 55.851,91.266 62.212,159.661c6.361,68.395 61.117,198.354 102.08,261.903c40.962,63.527 76.847,142.309 76.847,142.309l149.484,182.97Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3244.472,2992.664c0,0 97.924,-249.305 75.785,-373.426c-22.139,-124.122 -150.734,-280.187 -254.367,-316.869c-103.648,-36.682 -212.04,-56.546 -212.04,-56.546c0,0 55.851,91.266 62.212,159.661c6.361,68.395 61.117,198.354 102.08,261.903c40.962,63.527 76.847,142.309 76.847,142.309l149.484,182.97Z",
    style: {
      fill: "#2286aa",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3235.928,3038.72c0,0 11.703,-333.23 65.209,-447.573c53.522,-114.354 176.156,-161.165 286.23,-179.557c110.074,-18.398 220.433,-20.08 220.433,-20.08c0,0 -77.769,77.801 -101.589,141.743c-23.821,63.937 -110.516,178.663 -166.658,232.497c-56.153,53.84 -111.324,122.952 -111.324,122.952l-192.3,150.017Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3512.245,2702.407c-50.396,7.935 -97.212,28.974 -136.083,56.239c-8.738,-33.987 -23.804,-65.101 -44.31,-90.603c-12.161,-15.131 -26.785,-32.079 -41.674,-48.811c-44.18,132.779 -54.25,419.483 -54.25,419.483l192.3,-150.023c0,0 55.172,-69.106 111.324,-122.952c18.193,-17.444 39.615,-41.34 61.058,-67.791c-27.502,-1.391 -56.331,-0.598 -88.366,4.458Z",
    style: {
      fill: "#d7680b",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3102.147,3146.999c-167.208,-9.703 -251.989,-56.703 -296.553,-60.799c-44.547,-4.091 -104.743,-22.484 -158.265,-33.351c-53.49,-10.867 -98.641,-44.278 -98.641,-44.278c0,0 137.668,-78.987 226.013,-84.652c88.329,-5.676 202.036,19.411 202.036,19.411c0,0 96.991,101.352 125.41,203.669Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2599.403,2699.745c98.102,19.524 170,36.742 221.824,38.995c51.857,2.253 168.89,-4.345 240.793,51.636c71.904,55.964 95.929,152.971 110.36,209.189c14.43,56.201 25.087,202.941 25.087,202.941l-40.138,-21.724c0,0 -137.113,-152.67 -207.329,-213.474c-70.238,-60.783 -326.632,-243.602 -350.598,-267.563Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2599.403,2699.745c98.102,19.524 170,36.742 221.824,38.995c51.857,2.253 168.89,-4.345 240.793,51.636c71.904,55.964 95.929,152.971 110.36,209.189c14.43,56.201 25.087,202.941 25.087,202.941l-40.138,-21.724c0,0 -137.113,-152.67 -207.329,-213.474c-70.238,-60.783 -326.632,-243.602 -350.598,-267.563Z",
    style: {
      fill: "#2286aa",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3194.281,3186.9c0,0 -83.208,-146.438 -112.182,-190.823c-28.99,-44.385 -82.496,-141.522 -158.313,-166.529c-75.79,-25.012 -147.15,-39.502 -189.492,-59.565c-42.375,-20.08 -134.892,-70.238 -134.892,-70.238c0,0 78.087,133.436 152.745,204.386c74.664,70.966 185.018,113.874 241.871,148.718c56.854,34.844 173.509,134.051 173.509,134.051l26.753,0Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3194.281,3186.9c0,0 -65.953,-116.068 -100.872,-172.857c-68.05,-24.705 -143.63,-34.823 -218.31,-24.597c45.722,25.136 89.504,45.372 118.92,63.403c56.854,34.844 173.509,134.051 173.509,134.051l26.753,0Z",
    style: {
      fill: "#d7680b",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3549.59,3048.138c113.243,-1.364 145.613,-39.124 190.209,-58.864c44.59,-19.762 103.379,-62.115 103.379,-62.115c0,0 -117.874,-31.211 -218.196,-28.974c-100.333,2.221 -169.445,22.295 -226.298,46.816c-56.854,24.516 -162.755,170.555 -162.755,170.555c0,0 228.756,-57.236 313.662,-67.419Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3235.928,3115.551c0,0 228.756,-57.231 313.662,-67.414c89.757,-1.078 128.709,-25.028 163.197,-44.736c-6.452,-3.962 -12.813,-7.531 -18.98,-10.479c-27.928,-13.341 -92.027,-23.901 -151.241,-22.392c53.22,-21.977 105.805,-42.628 138.805,-53.064c15.703,-4.965 30.289,-9.04 44.385,-12.813c-32.219,-4.248 -67.462,-7.218 -100.781,-6.469c-100.333,2.221 -169.445,22.295 -226.298,46.816c-56.848,24.511 -162.75,170.55 -162.75,170.55Z",
    style: {
      fill: "#d7680b",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3176.854,3215.89c0,0 18.441,-107.19 -9.185,-137.781c-27.61,-30.559 -97.843,-105.249 -106.759,-173.256c-8.932,-67.985 -16.716,-146.023 20.058,-210.677c36.79,-64.67 91.407,-132.671 91.407,-132.671c0,0 80.259,82.512 125.965,139.36c45.722,56.837 64.67,141.571 45.722,224.061c-18.953,82.48 -89.477,138.331 -95.881,171.175c-6.388,32.812 -39.011,119.782 -39.011,119.782l-32.316,0l0,0.005Z",
    style: {
      fill: "#f07b19",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3167.528,3077.952c0.049,0.049 0.097,0.124 0.14,0.156c27.626,30.591 9.185,137.781 9.185,137.781l32.321,0c0,0 32.618,-86.97 39.011,-119.782c6.409,-32.844 76.928,-88.695 95.881,-171.175c7.358,-32.046 8.943,-64.433 5.504,-95.385c-44.563,40.563 -124.553,152.998 -152.098,209.076c-6.458,13.164 -17.163,26.483 -29.944,39.329Z",
    style: {
      fill: "#d7680b",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3245.966,3154.853c0,0 72.454,-113.944 146.023,-146.282c73.564,-32.37 209.582,-90.329 273.126,-110.392c63.527,-20.08 108.629,-25.643 178.059,-55.743c69.413,-30.101 109.551,-60.201 109.551,-60.201c0,0 -104.791,8.927 -187.287,0c-82.496,-8.91 -148.276,-28.99 -240.238,-14.49c-91.962,14.49 -172.221,72.454 -213.469,132.655c-41.248,60.196 -37.884,96.986 -49.593,137.113c-11.719,40.121 -34.014,72.47 -46.277,92.533c-12.274,20.063 -43.48,85.844 -43.48,85.844l44.596,0l28.99,-61.037Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3248.887,3072.066c-11.277,24.182 -24.532,44.073 -33.022,57.98c-12.274,20.063 -43.48,85.844 -43.48,85.844l44.596,0l28.99,-61.037c0,0 52.649,-82.771 113.766,-127.237c-33.734,6.312 -72.427,21.346 -110.85,44.45Z",
    style: {
      fill: "#d7680b",
      fillOpacity: 0.6,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3843.178,3184.113c27.324,13.379 70.81,18.392 70.81,18.392c0,0 -31.782,-39.297 -61.042,-76.087c-29.26,-36.774 -75.246,-76.912 -113.702,-95.309c-38.456,-18.398 -145.613,-31.48 -214.04,-15.05c58.53,40.138 90.296,61.037 135.447,77.752c45.145,16.732 141.819,59.371 182.528,90.302Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3255.992,3189.121c104.506,-20.063 190.635,-57.678 253.337,-65.214c62.702,-7.514 130.418,-12.528 183.099,0c52.665,12.544 150.751,60.201 150.751,60.201c0,0 -78.022,-86.954 -123.173,-112.025c-45.135,-25.087 -47.652,-20.899 -106.171,-40.973c-58.535,-20.063 -76.917,-33.448 -141.296,-25.917c-64.384,7.514 -130.418,54.331 -163.866,94.468c-33.448,40.143 -52.681,89.461 -52.681,89.461Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3587.367,3116.996c0.016,-25.281 -5.186,-44.773 -15.336,-56.633c-15.05,-17.557 -91.967,-29.26 -153.845,-29.26c-9.185,0 -18.08,0.679 -26.656,1.838c-27.783,15.287 -52.649,34.828 -71.268,53.97c28.656,4.695 60.503,18.807 86.221,31.987c11.104,5.682 20.441,13.325 29.292,21.756c27.168,-7.865 51.792,-14.128 73.553,-16.743c25.626,-3.078 52.094,-5.709 78.038,-6.916Z",
    style: {
      fill: "#d7680b",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3193.284,3215.89c0,0 10.878,-102.845 -37.615,-124.585c-48.493,-21.724 -301.814,-10.037 -301.814,-10.037c0,0 25.087,42.644 130.418,80.275c105.346,37.615 164.707,54.347 164.707,54.347l44.304,0Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3236.769,3215.89l-39.297,0c0,0 20.063,-60.201 44.326,-86.97c24.23,-26.753 35.098,-35.114 35.098,-35.114l200.656,0l23.427,20.08c0,0 -51.016,49.318 -69.397,55.172c-18.398,5.849 -91.137,9.196 -121.238,20.063c-30.106,10.878 -73.575,26.769 -73.575,26.769Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2965.525,3152.632l-115.906,275.778l69.252,420.83c0,0 13.147,67.667 99.32,67.667l367.853,0c86.156,0 99.32,-67.667 99.32,-67.667l69.252,-420.83l-115.906,-275.778l-473.183,0Z",
    style: {
      fill: "#969696",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2965.525,3152.632l-115.906,275.778l705.001,0l-115.912,-275.778l-473.183,0Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.1,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3167.674,3099.299c-32.084,-5.493 -57.991,11.245 -83.068,32.144c-25.087,20.921 -67.732,32.591 -101.163,56.854c-33.443,24.23 -84.458,66.874 -107.853,87.773c-23.406,20.904 -109.535,81.941 -109.535,81.941c0,0 -21.74,-56.584 -10.862,-129.884c10.862,-73.278 28.419,-120.553 57.678,-150.017c29.26,-29.432 88.631,-57.883 113.702,-57.883c25.087,0 74.427,23.427 117.895,30.958c43.485,7.52 106.538,21.837 123.205,48.116Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3262.142,3107.482c33.987,-3.649 79.132,15.589 113.421,33.157c34.267,17.557 51.824,53.511 89.439,75.251c37.631,21.724 79.434,68.54 81.1,58.514c1.682,-10.021 -0.825,-50.164 6.69,-95.309c7.536,-45.151 3.347,-79.434 -11.703,-96.991c-15.05,-17.557 -91.962,-29.26 -153.839,-29.26c-61.851,0.005 -111.454,28.155 -125.108,54.638Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2220.322,
    cy: 4093.155,
    rx: 2128.889,
    ry: 139.393,
    style: {
      fill: "#464343",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2702.453,3515.342l-949.983,0l-27.653,-226.584l778.123,0l199.61,94.706l-0.097,131.878Z",
    style: {
      fill: "#724746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2351.936,4067.453c-1028.242,0 -1864.771,-836.529 -1864.771,-1864.766c0,-1028.237 836.529,-1864.777 1864.771,-1864.777c180.183,0 358.7,25.831 530.576,76.771l-179.962,607.218c-113.432,-33.621 -231.392,-50.665 -350.614,-50.665c-679.024,0 -1231.453,552.429 -1231.453,1231.453c0,679.024 552.429,1231.448 1231.453,1231.448c119.222,0 237.182,-17.045 350.614,-50.665l179.962,607.223c-171.876,50.929 -350.393,76.761 -530.576,76.761Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1660.384,2452.687l203.432,174.145l354.15,-7.455c17.476,-8.738 140.094,-67.672 150.433,-68.427c10.307,-0.749 14.447,1.472 21.411,5.752c6.965,4.285 76.658,60.406 78.437,62.659c1.747,2.264 -4.124,32.904 -4.124,32.904l-239.92,53.63c0,0 -308.304,104.08 -340.022,112.392c-31.734,8.291 -26.516,10.307 -56.994,-2.361c-30.478,-12.689 -308.379,-183.875 -308.379,-183.875l141.576,-179.363Z",
    style: {
      fill: "#f7a486",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1984.655,2811.64l560.924,-195.249l13.358,39.669l-564.859,183.606l-9.423,-28.025Z",
    style: {
      fill: "#383838",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2747.474,2075.245l-188.538,580.815l-33.4,-25.901l204.364,-560.725l17.573,5.811Z",
    style: {
      fill: "#383838",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.37,2232.195c-32.984,14.209 -42.121,23.341 -40.596,56.325c1.526,32.984 3.046,57.349 3.046,57.349l-217.194,0c0,0 37.556,-133.436 38.057,-221.495l144.632,0l72.055,107.821Z",
    style: {
      fill: "#ffcea6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435.239,2168.98c0,0 45.846,103.573 111.567,159.3c-0.571,-10.134 -1.299,-23.901 -2.032,-39.76c-1.52,-32.984 7.611,-42.116 40.596,-56.325l-69.839,-104.506l-80.291,0l0,41.291Z",
    style: {
      fill: "#f7a486",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.197,1816.782c-6.614,-41.534 -46.245,-95.735 -49.032,-91.266c-2.792,4.49 0.032,28.208 0.032,28.208c-24.457,-31.098 -120.381,-70.281 -121.049,-61.91c-0.668,8.371 16.603,56.072 30.51,75.197c-42.757,-10.673 -136.191,27.006 -137.145,32.904c-0.949,5.935 32.893,39.248 62.131,54.837c-30.446,16.096 -47.431,54.633 -44.687,56.789c2.76,2.172 58.169,14.619 77.817,12.29c-21.885,53.237 -23.33,166.496 92.043,152.761c115.351,-13.751 118.639,-14.128 118.639,-14.128l-29.26,-245.683Z",
    style: {
      fill: "#724746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.6,1894.426l66.271,-7.897l21.681,181.864c-16.732,2.011 -38.968,4.657 -68.734,8.21c-36.203,4.302 -60.896,-3.887 -77.057,-18.807c14.581,-79.445 57.84,-163.37 57.84,-163.37Z",
    style: {
      fill: "#945143",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700.171,1828.344c93.121,42.914 116.607,220.196 -37.949,226.978l-120.3,-3.725l7.024,-227.899l151.225,4.647Z",
    style: {
      fill: "#724746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.388,2040.04c-16.112,8.657 -36.283,14.204 -61.166,15.282l-39.043,-1.207l4.868,-158.421l64.497,2c14.748,15.304 42.294,81.321 30.844,142.347Z",
    style: {
      fill: "#945143",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.429,2096.031c-23.152,-8.512 -27.341,-27.292 -27.023,-37.157c0.286,-9.848 7.973,-28.257 14.797,-72.885c6.819,-44.579 -6.328,-103.363 -53.743,-151.02c-148.896,-125.469 -347.186,-36.494 -358.225,123.41c-10.404,150.131 75.93,190.759 132.24,191.487c41.647,84.857 137.145,120.51 187.794,123.933c50.665,3.412 47.814,-11.891 50.239,-18.775c2.426,-6.862 1.903,-36.887 2.302,-38.391c0.394,-1.504 19.584,-13.988 20.311,-16.161c0.76,-2.189 -2.49,-13.816 -6.884,-16.651c1.364,0.032 15.223,-6.436 20.888,-15.907c1.251,-2.108 -4.474,-11.843 -1.224,-22.597c0.809,-2.679 7.088,-7.547 11.261,-10.495c4.151,-2.916 16.921,-22.166 17.002,-25.249c0.108,-3.04 1.472,-9.396 -9.735,-13.541Z",
    style: {
      fill: "#ffcea6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.918,2130.729c3.267,-2.9 2.269,-6.862 -2.092,-6.312c-4.55,0.598 -9.784,3.649 -9.784,3.649c0,0 7.611,4.043 11.875,2.663Z",
    style: {
      fill: "#bf6d58",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.497,2049.441c-0.318,10.986 4.932,20.047 11.751,20.252c6.835,0.221 12.625,-8.485 12.937,-19.492c0.35,-10.959 -4.9,-20.026 -11.719,-20.247c-6.803,-0.21 -12.603,8.528 -12.97,19.487Z",
    style: {
      fill: "#383838",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.263,2040.309c-12.56,-5.757 -30.478,-10.738 -45.976,16.635c-5.865,0.097 -14.856,-4.237 -17.427,-8.452c5.789,-1.951 13.476,-3.504 13.476,-3.504c5.709,-7.832 18.112,-18.398 31.238,-17.999c11.584,0.329 18.371,7.051 18.689,13.32Z",
    style: {
      fill: "#262626",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661.92,2008.322c-13.525,-7.735 -42.261,-10.463 -65.031,-4.388c-1.871,0.113 9.611,-8.894 17.967,-10.835c8.388,-1.935 27.675,-5.423 46.148,0.571c4.501,3.197 5.277,10.873 0.916,14.651Z",
    style: {
      fill: "#262626",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700.171,1828.344c-2.048,67.845 -84.065,218.099 -258.269,229.689c-9.024,-15.19 -44.31,-38.138 -68.982,-8.307c-24.694,29.858 -4.188,91.644 51.555,100.145c-36.079,14.463 -90.469,16.888 -123.965,2.253c-33.507,-14.608 -55.059,-64.842 -51.857,-102.085c3.186,-37.248 -5.072,-171.951 81.925,-257.536c91.056,-89.504 266.765,-88.172 369.594,35.841Z",
    style: {
      fill: "#724746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.461,2037.867l18.155,-89.886l105.028,3.218l16.667,87.919c-24.295,8.851 -56.848,16.937 -86.41,18.915c-7.773,-13.083 -29.022,-27.368 -53.441,-20.166Z",
    style: {
      fill: "#945143",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407.807,1926.079l102.365,9.417c0,0 -0.539,243.171 -7.595,248.184c-7.094,4.986 -92.043,-130.132 -94.77,-257.601Z",
    style: {
      fill: "#724746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.146,2186.014c0,0 -3.283,0.377 -8.517,-0.054c-5.331,-0.065 -11.832,-1.79 -18.511,-3.17c-6.582,-1.666 -12.797,-4.377 -17.492,-6.264c-4.647,-2 -7.66,-3.488 -7.66,-3.488c-1.062,-0.539 -1.493,-1.806 -0.97,-2.868c0.431,-0.873 1.396,-1.315 2.302,-1.159l0.189,0.032c0,0 3.299,0.636 8.118,1.795c2.377,0.647 5.202,1.283 8.134,2.199c2.932,0.889 6.043,2.016 9.261,2.571c6.312,1.509 12.657,3.477 17.303,4.302c4.63,1.207 8.021,1.725 8.021,1.725c1.207,0.189 2.016,1.315 1.822,2.523c-0.14,0.986 -0.949,1.725 -1.903,1.838l-0.097,0.016Z",
    style: {
      fill: "#bf6d58",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2587.177,3708.64l33.529,197.896l-130.962,4.124l-85.019,-231.883l182.452,29.863Z",
    style: {
      fill: "#ffcea6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2615.693,3876.948c8.706,-0.275 13.541,-0.081 14.145,7.336c0.62,7.407 8.102,57.349 8.102,57.349c0,0 165.246,92.803 186.872,108.419c21.632,15.611 22.834,28.834 25.233,44.45c2.41,15.622 4.819,33.637 -18.619,33.637l-311.22,0c-30.052,0 -50.477,-13.8 -50.477,-43.248c0,-29.448 17.557,-136.892 17.557,-136.892c0,0 -11.563,-33.561 -12.387,-39.776c-0.809,-6.215 -1.331,-13.649 7.708,-17.029c9.04,-3.342 133.086,-14.247 133.086,-14.247Z",
    style: {
      fill: "#f0eee9",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2956.124,3288.408l102.743,172.426l-120.618,51.15l-163.057,-185.514l180.932,-38.062Z",
    style: {
      fill: "#ffcea6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3039.493,3430.798c7.768,-3.903 12.258,-5.735 15.907,0.733c3.682,6.469 31.383,48.682 31.383,48.682c0,0 188.921,15.066 215.102,20.171c26.182,5.105 32.812,16.64 41.534,29.815c8.722,13.191 18.473,28.51 -2.808,38.343c-21.298,9.8 -255.353,117.766 -282.629,130.342c-27.276,12.576 -51.603,8.614 -63.942,-18.123c-12.323,-26.737 -41.388,-131.657 -41.388,-131.657c0,0 -24.548,-25.626 -27.912,-30.925c-3.331,-5.31 -6.916,-11.843 -0.129,-18.694c6.803,-6.835 114.882,-68.686 114.882,-68.686Z",
    style: {
      fill: "#f0eee9",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3043.234,3344.69l-409.43,-608.058c-41.943,-48.714 -83.903,-81.181 -173.218,-58.185c-89.315,22.996 -535.891,177.266 -535.891,177.266l-35.189,-8.118l-280.839,331.553c0,0 187.46,151.57 435.104,109.61l211.108,0l181.342,553.474c0,0 113.039,3.698 227.344,-21.648l-105.174,-676.124l286.516,313.457c0,0 104.554,-43.102 198.327,-113.227Z",
    style: {
      fill: "#616594",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2478.294,2889.948c-2.189,-0.41 -6.215,0.528 -123.518,34.284c-134.703,38.774 -360.16,103.681 -391.086,105.713c-0.189,0 -0.431,0.016 -0.685,0.016c-11.751,0 -86.016,-12.732 -147.656,-23.74c51.415,-83.461 82.464,-156.712 82.464,-156.712l-8.312,-1.914l-126.375,149.198l-2.792,3.294l-151.672,179.061c0,0 12.829,10.323 36.046,24.812c65.128,-45.339 122.477,-120.742 166.07,-190.392c59.77,10.608 142.729,24.883 153.43,24.467c31.809,-2.059 249.057,-64.605 392.795,-105.993c60.023,-17.287 112.182,-32.305 119.081,-33.987c20.047,19.346 299.172,333.434 460.052,514.981c2.393,-1.315 4.819,-2.679 7.261,-4.059c-458.472,-517.407 -463.361,-518.673 -465.103,-519.029Z",
    style: {
      fill: "#969696",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.343,2319.92c-60.104,-33.939 -187.508,-56.277 -195.864,-56.611c-8.361,-0.34 -15.794,4.043 -19.859,10.986c-4.059,6.948 -50.762,112.5 -56.169,309.404c-5.412,196.893 96.668,454.721 334.211,595.45c114.386,-54.142 240.238,-220.595 280.839,-331.553l-109.616,-150.212c0,0 -42.978,-174.566 -53.619,-194.198c-10.635,-19.638 -179.924,-183.266 -179.924,-183.266Z",
    style: {
      fill: "#f07b19",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.007,2704.251c99.735,103.347 338.846,223.35 297.183,367.691c65.273,-70.459 120.828,-157.44 145.312,-224.347l-109.616,-150.212c0,0 -26.182,-106.36 -42.741,-162.372l-136.493,-61.355l-153.645,230.595Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2560.047,3040.413c-19.616,-3.396 -58.864,2.711 -68.335,6.776c-9.466,4.059 -447.939,241.564 -447.939,241.564l211.108,0l139.393,-64.718l131.593,615.702c3.994,-0.27 8.102,-0.582 12.274,-0.916l-132.525,-620.047l154.95,-71.936l-9.989,-79.353c0,0 36.537,-4.744 42.628,-10.835c6.091,-6.086 -13.541,-12.84 -33.157,-16.236Z",
    style: {
      fill: "#616594",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.482,2543.091l223.506,147.5l350.49,-51.415c16.236,-10.83 130.59,-84.55 140.74,-86.588c10.15,-2.032 14.527,-0.329 21.966,3.046c7.439,3.38 83.59,50.401 85.617,52.433c2.027,2.027 0,33.157 0,33.157l-231.403,83.035c0,0 -292.968,141.597 -323.413,153.775c-30.446,12.183 -25.028,13.546 -56.837,4.744c-31.809,-8.803 -328.836,-144.12 -328.836,-144.12l118.17,-195.567Z",
    style: {
      fill: "#ffcea6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.352,2771.74c60.341,-80.421 92.803,-197.136 92.803,-197.136l-47.674,-31.513l-118.176,195.567c0.005,0.005 30.543,13.913 73.047,33.081Z",
    style: {
      fill: "#f7a486",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686.533,2543.091c0,0 -65.618,172.56 -126.52,233.457c-63.608,-37.221 -115.685,-69.02 -161.709,-113.675c-46.024,-44.655 -57.533,-187.417 14.193,-232.756c71.726,-45.339 119.777,-0.679 149.543,16.242c29.772,16.921 124.493,96.732 124.493,96.732Z",
    style: {
      fill: "#f07b19",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2474.807,2608.068c-2.032,-2.032 -78.184,-49.053 -85.617,-52.433c-5.38,-2.442 -9.202,-3.946 -14.716,-3.87c7.595,10.409 19.454,28.122 22.85,41.69c3.612,14.511 8.264,51.603 10.625,71.764l66.858,-23.993c0,0.005 2.027,-31.13 0,-33.157Z",
    style: {
      fill: "#f7a486",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.012,3056.369c-0.016,-129.323 104.807,-234.152 234.136,-234.152c129.329,0 234.152,104.824 234.152,234.152c0,129.329 -104.824,234.152 -234.152,234.136",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#616594",
      strokeWidth: "178.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.53,1406.969l112.721,64.955l112.737,-64.955l112.677,64.955l112.78,-64.955l112.85,64.955l112.866,-64.955",
    style: {
      fill: "#724746",
      fillRule: "nonzero",
      stroke: "#724746",
      strokeWidth: "97.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4034.164,3024.878l157.516,-272.851l157.521,272.851l-315.037,0Z",
    style: {
      fill: "#2286aa",
      fillRule: "nonzero",
      stroke: "#724746",
      strokeWidth: "97.43px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 706.66,
    y: 3380.672,
    width: 358.047,
    height: 123.809,
    style: {
      fill: "#f7a486"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1064.708,
    y: 3380.672,
    width: 777.142,
    height: 123.809,
    style: {
      fill: "#ffcea6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1730.018,
    y: 3504.481,
    width: 73.661,
    height: 623.659,
    style: {
      fill: "#525252"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.283,
    y: 3504.481,
    width: 73.661,
    height: 623.659,
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 772.505,
    y: 3504.481,
    width: 73.661,
    height: 623.659,
    style: {
      fill: "#525252"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.283,
    y: 3974.03,
    width: 343.73,
    height: 47.42,
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 809.327,
    y: 3974.03,
    width: 343.746,
    height: 47.42,
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.235,
    y: 3504.481,
    width: 73.661,
    height: 623.659,
    style: {
      fill: "#525252"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1254.755,3280.543l353.325,0l0,-23.707l-693.153,0c-32.683,0 -59.279,26.597 -59.279,59.263l0,5.293c0,32.688 26.597,59.279 59.279,59.279l693.153,0l0,-23.707l-353.325,0c-19.6,0 -35.572,-15.972 -35.572,-35.572l0,-5.293c-0,-19.605 15.972,-35.556 35.572,-35.556Z",
    style: {
      fill: "#d7680b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.08,3380.672l-353.325,0c-32.683,0 -59.279,-26.597 -59.279,-59.279l0,-5.293c0,-32.666 26.597,-59.263 59.279,-59.263l353.325,0l0,23.707l-353.325,0c-19.6,0 -35.572,15.95 -35.572,35.556l0,5.293c0,19.6 15.967,35.572 35.572,35.572l353.325,0l0,23.707Z",
    style: {
      fill: "#ff7373",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.755,3280.543c-19.6,0 -35.572,15.95 -35.572,35.556l0,5.293c0,19.6 15.967,35.572 35.572,35.572l320.152,0l0,-76.421l-320.152,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1328.831,3256.739l-185.05,0l-20.376,-257.003l225.84,0l-20.414,257.003Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.451,2965.755l-186.274,0c-18.937,0 -34.284,15.352 -34.284,34.3l0,33.825l254.857,0l0,-33.825c0,-18.953 -15.352,-34.3 -34.3,-34.3Z",
    style: {
      fill: "#383838",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.52,3214.014l11.988,-142.913l-226.374,0l11.951,142.913l202.435,0Z",
    style: {
      fill: "#616594",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3337.582,683.189c82.488,-44.644 185.703,-13.919 230.347,68.569c44.644,82.488 13.919,185.703 -68.569,230.347c-82.488,44.644 -185.703,13.919 -230.347,-68.569c-44.644,-82.488 -13.919,-185.703 68.569,-230.347Z",
    style: {
      fill: "#616594",
      fillOpacity: 0,
      stroke: "#616594",
      strokeWidth: "97.44px"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/header-img.62c3973750be6858ac3137773560634f.svg";
export { ForwardRef as ReactComponent };